import { useEffect, useRef } from 'react';

const useFullLabelWidth = () => {
    const ref = useRef<HTMLElement>();

    useEffect(() => {
        const root = ref.current?.shadowRoot;
        if (!root) {
            return;
        }

        const observer = new MutationObserver(() => {
            const label = root.querySelector('label#label') as HTMLLabelElement;
            if (!label) {
                return;
            }

            label.style.width = '100%';
            observer.disconnect();
        });
        observer.observe(root, { subtree: true, childList: true });
    }, []);

    return ref;
};

export default useFullLabelWidth;
